import api from '../api';
import { CommunityEndpoints } from './constants';

class CommunityService {
  static async  getMigrationCommunities (type, rows, communityId, nextPageToken, membership)  {
    const communityIdParam = communityId ? `&communityId=${communityId}` : '';
    const nextPageTokenParam = nextPageToken ? `&nextPageToken=${nextPageToken}` : '';
    const membershipParam = membership ? `&slug=${membership}` : '';
    const url = `${CommunityEndpoints.getMigrationCommunities()}?type=${type}&rows=${rows}${communityIdParam}${nextPageTokenParam}${membershipParam}`;
  
    const res = await api.get(url)
  
    return res.data
  }

  static async getMemberships (rows, nextPageToken) {
    const nextPageTokenParam = nextPageToken ? `&nextPageToken=${nextPageToken}` : '';
    const url = `${CommunityEndpoints.getMemberships()}?rows=${rows}${nextPageTokenParam}`;

    const res = await api.get(url)

    return res.data
  }

  static async putMigrationCommunity (communityId, membershipSlug, communityType, groupId) {
    const groupIdParam = groupId ? `&groupId=${groupId}` : '';
    const url = `${CommunityEndpoints.putMigrationCommunity(communityId, membershipSlug)}?type=${communityType}${groupIdParam}`;
  
    const res = await api.put(url)
  
    return res.data
  }

  static async putFollowPublicCommunity (communityId) {
    const url = CommunityEndpoints.putFollowPublicCommunity(communityId)

    const rest = await api.put(url)

    return rest.data
  }

  static async putUnfollowPublicCommunity (communityId) {
    const url = CommunityEndpoints.putUnfollowPublicCommunity(communityId)

    const rest = await api.put(url)

    return rest.data
  }
}

export default CommunityService
